function normalizeBasePath(basePath: string) {
  const withLeadingSlash = basePath.startsWith("/") ? basePath : `/${basePath}`;
  return withLeadingSlash.replace(/\/+$/, "") || "/";
}

export function resolveAdminBasePath(
  pathname: string,
  configuredBasePath = "/admin",
) {
  const configured = normalizeBasePath(configuredBasePath);
  const adminSegment = configured.slice(configured.lastIndexOf("/"));
  const segmentIndex = pathname.indexOf(adminSegment);

  if (segmentIndex >= 0) {
    const segmentEnd = segmentIndex + adminSegment.length;
    if (segmentEnd === pathname.length || pathname[segmentEnd] === "/") {
      return pathname.slice(0, segmentEnd) || configured;
    }
  }

  return configured;
}
